import { Controller } from "@hotwired/stimulus"

// «Aggiungi il capitolato» e «Il decreto non ripartisce gli importi per voce» di SenzaTabella (Decreto.js, 31a5bd1):
// il pulsante si accende quando ogni campo ha del testo (`!f.codice || …`) o, con data-campi-richiesti-minimo, almeno
// quel numero di caratteri senza gli spazi ai bordi (`frase.trim().length < 10`). L'invio e' del form.
export default class extends Controller {
  static targets = ["campo", "invia"]

  connect() { this.controlla() }

  controlla() {
    this.inviaTarget.disabled = !this.campoTargets.every((c) => {
      const minimo = c.dataset.campiRichiestiMinimo
      return minimo ? c.value.trim().length >= Number(minimo) : c.value !== ""
    })
  }
}
